import { RootState } from "../../store";
import { AccountAttempt } from "../../../services/cloudchipr.api";

export const accountAttemptSelector = (
  state: RootState,
): AccountAttempt | null => state.accountSetup.accountAttempt;
